import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from './Footer';

interface PublicPageLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
}

const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({
  children,
  title,
  subtitle,
  showBackButton = true
}) => {

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-4">
        {showBackButton && (
          <Link
            to="/"
            className="inline-flex items-center text-sm text-fg-muted hover:text-fg-bright mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Terug naar Solofix
          </Link>
        )}

        <div className="flex items-center gap-2.5 mb-8">
          <span className="sf-logo-mark h-[34px] w-[34px] text-[19px]">S</span>
          <span className="text-xl font-extrabold tracking-tight text-fg-bright">SOLOFIX</span>
        </div>

        <div className="sf-eyebrow mb-3">// solofix</div>
        <h1 className="sf-h1 mb-4">{title}</h1>
        {subtitle && (
          <p className="text-fg-muted text-lg">{subtitle}</p>
        )}
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-16">
        <div
          className="sf-card p-6 sm:p-10 text-fg-body [&_h2]:text-fg-bright [&_h3]:text-fg-bright [&_h4]:text-fg-bright [&_strong]:text-fg-soft [&_a]:text-neon-cyan [&_.text-gray-900]:text-fg-bright [&_.text-gray-800]:text-fg-body [&_.text-gray-700]:text-fg-body [&_.text-gray-600]:text-fg-muted [&_.text-gray-500]:text-fg-muted [&_.bg-white]:bg-white/[.04] [&_.bg-gray-50]:bg-white/[.03] [&_.border-gray-200]:border-white/[.08] [&_.border-gray-100]:border-white/[.08]"
        >
          {children}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PublicPageLayout;
